<template>
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.45946 1L14 5.5M14 5.5L9.45946 10M14 5.5H0"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {
  name: "CustomArrowRightIcon",
};
</script>
